export default __webpack_public_path__ + "static/media/database.11f5a7c4.jpeg";